export default __webpack_public_path__ + "static/media/Creative-hover.bed413d6.svg";